import { parseJSON } from "date-fns";
import instance from "../axiosConfig";
import { CommentEntry, CreateComment, CreateCommentResponse } from "./models";

export class CommentsService {
    private regionCode: string;
    private languageCode: string;

    constructor(regionCode: string, languageCode: string) {
        this.regionCode = regionCode;
        this.languageCode = `${regionCode}-${languageCode}`;
    }

    postOnElementPage = async (slug: string, comment: CreateComment): Promise<CommentEntry> => {
        const response = await instance.post<CreateCommentResponse>(
            `api/Regions/${this.regionCode}/Languages/${this.languageCode}/ElementPages/${slug}/Comments`,
            comment,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return {
            id: response.data.id,
            username: response.data.createdBy,
            commentBlob: response.data.comment,
            commentDate: parseJSON(response.data.creationDate),
            isAdmin: response.data.isAdminComment,
            replies: [],
        };
    };

    postOnContentPage = async (slug: string, comment: CreateComment): Promise<CommentEntry> => {
        const response = await instance.post<CreateCommentResponse>(
            `api/Regions/${this.regionCode}/Languages/${this.languageCode}/Pages/${slug}/Comments`,
            comment,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return {
            id: response.data.id,
            username: response.data.createdBy,
            commentBlob: response.data.comment,
            commentDate: parseJSON(response.data.creationDate),
            isAdmin: response.data.isAdminComment,
            replies: [],
        };
    };
}
